import { formatDate, formatTime } from '@smarttransit/common'
import moment from 'moment-timezone'
import { updateQueryParams } from '@smarttransit/common-client'

import {
  archiveStRoute,
  deleteStRoute,
  findStRoutes,
  findTotalStRoutes
} from '@/services/st-routes-service'

import {
  isAuthorized,
  initBreadcrumbs,
  isOnlyInvestor as isOnlyInvestorFn
  // addAlert
} from '../../../utilities/helpers'

export default {
  props: {
    signedInUser: Object,
    forceRootViewRefresh: Function
  },
  data () {
    return {
      routes: [],
      breadcrumbs: [],
      totalRoutes: 0,
      totalArchivedRoutes: 0,
      apiInProgress: false,
      pagination: { sortBy: 'dateUpdated', descending: true },
      selectedRouteTab: 'routes',
      selectedAgencyId: null,
      searchKeywords: '',
      activeHeaders: [],
      archivedHeaders: [],
      agencies: [],
      dateFromMenu: null,
      dateFrom: null,
      dateToMenu: null,
      dateTo: null,
      componentMounted: false
    }
  },
  watch: {
    $route () {
      this.breadcrumbs = initBreadcrumbs.call(this)

      if (this.$router.currentRoute.name === 'routes') {
        initTableHeaders.call(this)
        this.loadFromQueryParams()
        this.searchRoutes(this.selectedRouteTab, 1).finally(() => {
          this.componentMounted = true
        })
      }
    }
    // dateFrom (val) {
    //   this.updateQueryParams({ dateFrom: val })
    // },
    // dateTo (val) {
    //   this.updateQueryParams({ dateTo: val })
    // },
    // pagination (updatedPagination) {
    //   this.updateQueryParams({ ...updatedPagination })
    // }
  },
  computed: {
    isOnlyInvestor () {
      return isOnlyInvestorFn(this.$props.signedInUser)
    },
    computedDateFromFormatted () {
      return this.dateFrom ? formatDate(this.dateFrom) : ''
    },
    computedDateToFormatted () {
      return this.dateTo ? formatDate(this.dateTo) : ''
    },
    computedDateFromMax () {
      const fromDateAsMoment = this.dateFrom ? moment(this.dateFrom, 'Y-MM-DD') : null
      const toDateAsMoment = this.dateTo ? moment(this.dateTo, 'Y-MM-DD') : null

      if (toDateAsMoment && (!fromDateAsMoment || fromDateAsMoment.valueOf() <= toDateAsMoment.valueOf())) {
        return toDateAsMoment.subtract(1, 'day').format('Y-MM-DD')
      }

      return ''
    },
    computedDateToMin () {
      const fromDateAsMoment = this.dateFrom ? moment(this.dateFrom, 'Y-MM-DD') : null
      const toDateAsMoment = this.dateTo ? moment(this.dateTo, 'Y-MM-DD') : null

      if (fromDateAsMoment && (!toDateAsMoment || fromDateAsMoment.valueOf() <= toDateAsMoment.valueOf())) {
        return fromDateAsMoment.add(1, 'day').format('Y-MM-DD')
      }

      return ''
    }
  },
  mounted: function () {
    this.agencies = this.$store.getters.getAgencies

    if (!this.selectedAgencyId) {
      this.selectedAgencyId = this.agencies[0].value
    }

    this.$nextTick(() => {
      this.breadcrumbs = initBreadcrumbs.call(this)
    })

    if (this.$router.currentRoute.name === 'routes') {
      initTableHeaders.call(this)
      this.loadFromQueryParams()
      this.searchRoutes(this.selectedRouteTab, 1).finally(() => {
        this.componentMounted = true
      })
    }
  },
  methods: {
    loadFromQueryParams () {
      if (this.$route.query.descending) {
        this.pagination.descending = this.$route.query.descending
      }

      if (this.$route.query.page) {
        this.pagination.page = this.$route.query.page
      }

      if (this.$route.query.rowsPerPage) {
        this.pagination.rowsPerPage = this.$route.query.rowsPerPage
      }

      if (this.$route.query.sortBy) {
        this.pagination.sortBy = this.$route.query.sortBy
      }

      if (this.$route.query.searchKeywords) {
        this.searchKeywords = this.$route.query.searchKeywords
      }

      if (this.$route.query.dateFrom) {
        this.dateFrom = this.$route.query.dateFrom
      }

      if (this.$route.query.dateTo) {
        this.dateTo = this.$route.query.dateTo
      }

      if (this.$route.query.agencyId) {
        this.selectedAgencyId = this.$route.query.agencyId
      }

      this.selectedRouteTab = ['routes', 'archived-routes'].includes(this.$route.query.tab)
        ? this.$route.query.tab
        : 'routes'
    },
    updateQueryParams (providedData) {
      const paramsObj = {
        searchKeywords: this.searchKeywords && this.searchKeywords.split(' ').map((o) => o.trim()),
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
        agencyId: this.selectedAgencyId,
        page: this.pagination.page,
        rowsPerPage: this.pagination.rowsPerPage,
        descending: this.pagination.descending,
        sortBy: this.pagination.sortBy,
        tab: this.selectedRouteTab,
        ...providedData
      }

      this.lastParams = updateQueryParams({ paramsObj, route: this.$route, lastParams: this.lastParams })
    },
    hasUserType (role) {
      const { signedInUser } = this.$props
      return (signedInUser && isAuthorized(signedInUser, role))
    },
    onPagination () {
      if (this.componentMounted) {
        this.searchRoutes(this.selectedRouteTab)
      }
    },
    onTabChanged (val) {
      this.selectedRouteTab = val
      this.pagination.page = 1
      this.updateQueryParams({ tab: val, page: 1 })

      if (this.componentMounted) {
        this.searchRoutes(val, 1)
      }
    },
    onFilterByAgency (val) {
      this.selectedAgencyId = val ? this.agencies.find((o) => (o.value === val)).value : null
      this.updateQueryParams({ agencyId: val })
      this.searchRoutes(this.selectedRouteTab, 1)
    },
    /**
     * @param {string} category - "routes" or "archived-routes"
     * @param {number} setPage - force the page to be this over whatever pagination has
     * @returns {Promise<void>}
     */
    async searchRoutes (category = this.selectedRouteTab, setPage) {
      try {
        this.selectedRouteTab = category
        let order
        const promises = []
        const isArchived = category === 'archived-routes'
        this.apiInProgress = true
        const { sortBy, descending, page, rowsPerPage } = this.pagination
        const offset = ((setPage || page) - 1) * (rowsPerPage || 0)
        const limit = rowsPerPage

        if (sortBy) {
          order = `${sortBy} ${descending ? 'DESC' : 'ASC'}`
        }

        promises.push(findStRoutes({
          keywords: String(this.searchKeywords).trim(),
          agencyId: this.selectedAgencyId,
          dateFrom: this.dateFrom,
          dateTo: this.dateTo,
          archived: isArchived,
          limit,
          offset,
          order
        }))

        promises.push(findTotalStRoutes({
          keywords: String(this.searchKeywords).trim(),
          agencyId: this.selectedAgencyId,
          dateFrom: this.dateFrom,
          dateTo: this.dateTo,
          archived: isArchived
        }))

        if (isArchived) {
          findTotalStRoutes({
            keywords: String(this.searchKeywords).trim(),
            agencyId: this.selectedAgencyId,
            dateFrom: this.dateFrom,
            dateTo: this.dateTo
          }).then((result) => {
            this.totalRoutes = typeof result === 'number' ? result : (result?.count || 0)
          })
        } else {
          findTotalStRoutes({
            keywords: String(this.searchKeywords).trim(),
            agencyId: this.selectedAgencyId,
            dateFrom: this.dateFrom,
            dateTo: this.dateTo,
            archived: true
          }).then((result) => {
            this.totalArchivedRoutes = typeof result === 'number' ? result : (result?.count || 0)
          })
        }

        const [results, totalPendingCountResult] = await Promise.all(promises)
        const totalCount = typeof totalPendingCountResult === 'number' ? totalPendingCountResult : (totalPendingCountResult?.count || 0)

        if (isArchived) {
          this.totalArchivedRoutes = totalCount
        } else {
          this.totalRoutes = totalCount
        }

        this.routes = results.map((o) => {
          return this.setRoute(o)
        })
      } finally {
        this.apiInProgress = false
      }
    },
    setRoute ({ id, label, routeIdList, agencyId, dateCreated, dateUpdated, dateArchived, routeLineData, metadata }) {
      const newObj = Object.assign({}, { id, label, routeIdList, agencyId, dateCreated, dateUpdated, dateArchived, routeLineData, flatRateFare: metadata?.flatRateFare })

      newObj.agencyLabel = this.agencies.find((o) => (o.value === agencyId))?.text || ''
      newObj.dateCreatedLabel = newObj.dateCreated ? `${formatTime(newObj.dateCreated)}, ${formatDate(newObj.dateCreated)}` : ''
      newObj.dateUpdatedLabel = newObj.dateUpdated ? `${formatTime(newObj.dateUpdated)}, ${formatDate(newObj.dateUpdated)}` : ''
      newObj.dateArchivedLabel = newObj.dateArchived ? `${formatTime(newObj.dateArchived)}, ${formatDate(newObj.dateArchived)}` : ''

      return newObj
    },
    async archiveRoute (route) {
      if (!route?.id || this.apiInProgress) {
        return
      }

      if (!confirm(`Confirm archiving route "${route.label}"`)) {
        return
      }

      try {
        this.apiInProgress = true
        await archiveStRoute(route.id)
        await this.searchRoutes(this.selectedRouteTab, 1)
      } finally {
        this.apiInProgress = false
      }
    },
    async deleteRoute (route) {
      if (!route?.id || this.apiInProgress) {
        return
      }

      if (!confirm(`Confirm permanent deletion of archived route "${route.label}"`)) {
        return
      }

      try {
        this.apiInProgress = true
        await deleteStRoute(route.id)
        await this.searchRoutes(this.selectedRouteTab, 1)
      } finally {
        this.apiInProgress = false
      }
    },
    loadRoute (routeId) {
      this.$router.push({ name: 'routes-route', params: { routeId } })
    }
  }
}

function initTableHeaders () {
  this.activeHeaders = [
    {
      text: 'Label',
      align: 'left',
      sortable: true,
      value: 'label'
    },
    {
      text: 'Route ID List',
      align: 'left',
      sortable: false
    },
    {
      text: 'Agency ID',
      align: 'left',
      sortable: true,
      value: 'agencyId'
    },
    {
      text: 'Date Created',
      align: 'left',
      sortable: true,
      value: 'dateCreated'
    },
    {
      text: 'Date Updated',
      align: 'left',
      sortable: true,
      value: 'dateUpdated'
    },
    { text: 'Actions', sortable: false }
  ]

  this.archivedHeaders = [
    {
      text: 'Label',
      align: 'left',
      sortable: true,
      value: 'label'
    },
    {
      text: 'Route ID List',
      align: 'left',
      sortable: false
    },
    {
      text: 'Agency ID',
      align: 'left',
      sortable: true,
      value: 'agencyId'
    },
    {
      text: 'Date Created',
      align: 'left',
      sortable: true,
      value: 'dateCreated'
    },
    {
      text: 'Date Archived',
      align: 'left',
      sortable: true,
      value: 'dateArchived'
    },
    { text: 'Actions', sortable: false }
  ]
}
